import { Consent, Options, Status } from 'cookieconsent';
import { Lang } from '../../lib/types';
import 'cookieconsent/build/cookieconsent.min.css';
import './cookieconsent-overrides.scss';

const texts: { [k in Lang]: Options['content'] } = {
    en: {
        message: 'Desajuste Creativo uses cookies to provide a better user experience.',
        allow: 'Allow',
        deny: 'Reject',
        link: 'Cookie Policy',
        policy: 'Cookie Policy',
        href: '/legal/cookies/',
    },
    es: {
        message: 'Desajuste Creativo utiliza cookies para brindarte una mejor experiencia.',
        allow: 'Aceptar',
        deny: 'Rechazar',
        link: 'Política de cookies',
        policy: 'Uso de cookies',
        href: '/legal/cookies/',
    }
};

const primaryColor = '#292e4b';
const secondaryColor = '#dda0bc';

declare const window: Window & { cookieconsent: Consent; };

export const initCookieConsent = (lang: Lang, onAllow: () => void): void => {
    require('cookieconsent');
    const cc: Consent = window.cookieconsent;
    const handleConsent = (status: Status): void => {
        if (status == 'allow') {
            onAllow();
        }
    };

    cc.initialise({
        palette: {
            popup: {
                background: primaryColor,
            },
            button: {
                background: secondaryColor
            }
        },
        cookie: {
            domain: window.location.hostname
        },
        theme: 'edgeless',
        type: 'opt-in',
        content: texts[lang],
        onStatusChange: handleConsent,
        onInitialise: handleConsent
    });
};